// extracted by mini-css-extract-plugin
export default {"title":"MyProfilePage_title__yC+PX","form":"MyProfilePage_form__y6noq"};